import * as React from "react";
import { SVGProps } from "react";
export const Chevron2LeftIcon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        width="1em"
        height="1em"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M15.909 17.458L8.97095 10.521C8.87428 10.4237 8.80495 10.323 8.76295 10.219C8.72095 10.115 8.69995 10.0073 8.69995 9.896C8.69995 9.78467 8.72095 9.677 8.76295 9.573C8.80495 9.469 8.87428 9.36833 8.97095 9.271L15.93 2.313C16.138 2.10433 16.3913 2 16.69 2C16.9886 2 17.242 2.11133 17.45 2.334C17.6726 2.542 17.777 2.79867 17.763 3.104C17.749 3.41 17.638 3.667 17.43 3.875L11.409 9.896L17.45 15.938C17.6446 16.132 17.742 16.3853 17.742 16.698C17.742 17.0107 17.6446 17.264 17.45 17.458C17.242 17.6667 16.9853 17.771 16.68 17.771C16.374 17.771 16.117 17.6667 15.909 17.458Z"
            fill="currentColor"
        />
        <path
            d="M9.40895 17.458L2.47095 10.521C2.37428 10.4237 2.30495 10.323 2.26295 10.219C2.22095 10.115 2.19995 10.0073 2.19995 9.896C2.19995 9.78467 2.22095 9.677 2.26295 9.573C2.30495 9.469 2.37428 9.36833 2.47095 9.271L9.42995 2.313C9.63795 2.10433 9.89128 2 10.19 2C10.4886 2 10.742 2.11133 10.95 2.334C11.1726 2.542 11.277 2.79867 11.263 3.104C11.249 3.41 11.138 3.667 10.93 3.875L4.90895 9.896L10.95 15.938C11.1446 16.132 11.242 16.3853 11.242 16.698C11.242 17.0107 11.1446 17.264 10.95 17.458C10.742 17.6667 10.4853 17.771 10.18 17.771C9.87395 17.771 9.61695 17.6667 9.40895 17.458Z"
            fill="currentColor"
        />
    </svg>
);
Chevron2LeftIcon.displayName = "Chevron2LeftIcon";
